import { render } from "./InStockList.vue?vue&type=template&id=3674bda8&scoped=true"
import script from "./InStockList.vue?vue&type=script&lang=js"
export * from "./InStockList.vue?vue&type=script&lang=js"

import "./InStockList.vue?vue&type=style&index=0&id=3674bda8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3674bda8"],['__file',"src/views/h5/common/stock/inStock/InStockList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3674bda8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3674bda8', __exports__)) {
    api.reload('3674bda8', __exports__)
  }
  
  module.hot.accept("./InStockList.vue?vue&type=template&id=3674bda8&scoped=true", () => {
    api.rerender('3674bda8', render)
  })

}


export default __exports__